import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-company",
  "use": "icon-menu-company-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-company\">\r\n<path d=\"M193.2,182.6h-12.1V89.1c0-8.4-4.7-16.2-12.1-18.6l-45.8-16.2v128.8h-8.9V19.6c0-6-2.6-12-6.8-15.6\r\n\tc-4.2-3.6-10-4.8-14.7-3.6L33.2,20.2c-7.4,2.4-12.6,9.6-12.1,18.6v144.4H7.4c-4.2,0-7.4,3.6-7.4,8.4c0,4.8,3.2,8.4,7.4,8.4h185.3\r\n\tc4.2,0,7.4-4.2,7.4-9C199.5,186.8,196.8,183.2,193.2,182.6L193.2,182.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/menu-company.svg
// module id = usAi
// module chunks = 13